import { produce } from "immer";
import {
    EOD_DAILY_SUMMARY_REQUEST,
    EOD_DAILY_SUMMARY_SUCCESS,
    EOD_DAILY_SUMMARY_FAILURE,
} from "./eodReportsConstants";

const initialNewReportsState = {
    // EOD Daily Summary
    eodDailySummaryLoading: false,
    eodDailySummarySuccess: [],
    eodDailySummaryFailure: false,
};

export default function eodReportsReducer(state = initialNewReportsState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case EOD_DAILY_SUMMARY_REQUEST:
                draft.eodDailySummaryLoading = true;
                draft.eodDailySummarySuccess = [];
                draft.eodDailySummaryFailure = false;
                break;
            case EOD_DAILY_SUMMARY_SUCCESS:
                draft.eodDailySummarySuccess = action.payload;
                draft.eodDailySummaryLoading = false;
                draft.eodDailySummaryFailure = false;
                break;
            case EOD_DAILY_SUMMARY_FAILURE:
                draft.eodDailySummarySuccess = [];
                draft.eodDailySummaryLoading = false;
                draft.eodDailySummaryFailure = true;
                break;

            default:
                break;
        }
    });
}
